import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, DeferLoadingStrategy, I18nModule, provideConfig, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ShimanoPaginationModule } from '../../pagination/pagination.module';
import { NewsListComponent } from './news-list.component';

@NgModule({
  declarations: [NewsListComponent],
  imports: [
    CommonModule,
    MediaModule,
    RouterModule,
    UrlModule,
    SlickCarouselModule,
    NgbPaginationModule,
    I18nModule,
    ShimanoPaginationModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        NewsListComponent: {
          component: NewsListComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        NewsRelatedArticles: {
          component: NewsListComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
        NewsResultListComponent: {
          component: NewsListComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class NewsListModule {}
